import { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import {
  featuredUniversities,
  benefits,
  destinations,
  testimonials,
  faqs,
  overseasUniversities,
  footerData,
} from "../Data/FeatureUni/overseasFeatureUniCN";
import FeatureUniApplyForm from "../Components/FeatureUni/FeatureUniApplyForm";
import SuccessMessage from "../Components/Notification/SuccessMessage";
import ErrorMessage from "../Components/Notification/ErrorMessage";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/logo/logo.jpeg";
import Footer from "../Components/FeatureUni/Footer";

const OverseasUniversitiesPageCN = () => {
  // const navigate = useNavigate();
  // const [activeTab, setActiveTab] = useState("overseas");
  const [activeUniversity, setActiveUniversity] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [visibleSections, setVisibleSections] = useState(new Set());
  const observerRef = useRef(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const showSuccess = (msg) => {
    setSuccessMessage(msg);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const showError = (msg) => {
    setErrorMessage(msg);
    setTimeout(() => setErrorMessage(""), 3000);
  };

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => new Set([...prev, entry.target.id]));
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observerRef.current.observe(el);
    });

    return () => observerRef.current?.disconnect();
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToUni) {
      const uniName = location.state.scrollToUni;
      const uniIndex = overseasUniversities.findIndex(
        (u) => u.name === uniName
      );

      if (uniIndex !== -1) {
        setActiveUniversity(uniIndex);
        // Add a small delay to ensure DOM is ready
        setTimeout(() => {
          document
            .getElementById("more-universities")
            ?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.state]);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Floating Navigation Bar */}
      <nav className="flex items-center justify-center fixed top-0 z-50 w-full shadow-lg bg-white h-20">
        <div className="w-full lg:w-[1024px] p-4 flex items-center justify-between">
          <Link to="/">
            <img src={Logo} alt="" className="w-20 h-20" />
          </Link>
        </div>
      </nav>

      <div className="fixed top-24 right-5 z-50 space-y-2">
        {successMessage && <SuccessMessage message={successMessage} />}
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>

      {/* Hero Section - Full Screen */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        {/* Animated Background Blobs */}
        <div className="absolute inset-0 overflow-hidden">
          <div
            className="absolute top-0 -left-20 w-72 h-72 bg-gradient-to-br from-blue-300/30 to-indigo-300/30 rounded-full blur-3xl"
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          ></div>
          <div
            className="absolute bottom-0 -right-20 w-96 h-96 bg-gradient-to-br from-purple-300/30 to-pink-300/30 rounded-full blur-3xl"
            style={{ transform: `translateY(${scrollY * -0.2}px)` }}
          ></div>
          <div
            className="absolute top-1/2 left-1/2 w-64 h-64 bg-gradient-to-br from-cyan-300/20 to-blue-300/20 rounded-full blur-3xl"
            style={{
              transform: `translate(-50%, -50%) scale(${1 + scrollY * 0.001})`,
            }}
          ></div>
        </div>

        <div className="relative z-10 px-4 sm:px-6 pt-24 pb-16 text-center max-w-2xl mx-auto">
          {/* Floating Badge */}
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-6 shadow-xl animate-bounce">
            <span className="text-lg">🌍</span>
            <span>全球留学</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mb-6 leading-tight">
            什么？在
            <span className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 bg-clip-text text-transparent">
              外国留学
            </span>
            <br />
            既然比本地便宜？
          </h1>

          <p className="text-lg sm:text-xl text-gray-700 mb-8 font-medium leading-relaxed">
            如何用
            <span className="font-black text-blue-600">马币</span>
            <span className="font-black text-red-600">100k </span>
            完成英国 degree
          </p>

          {/* Key Benefits Pills */}
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            <div className="bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold border-2 border-blue-200 flex items-center gap-2">
              <span>✓</span> 课程选择
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold border-2 border-indigo-200 flex items-center gap-2">
              <span>✓</span> 签证指导
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold border-2 border-purple-200 flex items-center gap-2">
              <span>✓</span> 快速申请
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold border-2 border-pink-200 flex items-center gap-2">
              <span>✓</span> 住宿安排
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <button
              onClick={() =>
                document
                  .getElementById("form-section")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="group relative bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 text-white font-black px-8 py-5 rounded-2xl shadow-2xl shadow-blue-500/50 hover:shadow-blue-500/70 transition-all duration-300 hover:scale-105 overflow-hidden cursor-pointer"
            >
              <span className="relative z-10 text-lg">免费海外留学咨询 🌏</span>
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-indigo-500 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>

          <p className="text-orange-600 font-bold animate-bounce">
            💡免费 IPad 给首50位同学！
          </p>
        </div>
      </section>

      {/* Lead Capture Form - Full Screen */}
      <section
        id="form-section"
        data-animate
        className="min-h-screen flex items-center py-20 bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 relative overflow-hidden"
      >
        {/* Animated Background */}
        <div className="absolute inset-0 overflow-hidden opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1.5s" }}
          ></div>
        </div>

        <div className="relative z-10 w-full px-4">
          <div className="max-w-lg mx-auto">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-bold mb-4 border border-white/30">
                🌍 海外留学
              </div>
              <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
                我要免费了解
                <br />
                海外留学和 FREE Ipad
              </h2>
              <p className="text-xl text-white/90 font-medium">
                我们将在24小时内联系您！ ⚡
              </p>
            </div>

            {/* Form */}
            <FeatureUniApplyForm
              onSuccess={showSuccess}
              onError={showError}
              campaign="Overseas Partner University Ads"
              universities={overseasUniversities.map((uni) => uni.fullName)}
            />
          </div>
        </div>
      </section>

      {/* Popular Destinations - Full Screen */}
      <section
        id="destinations"
        data-animate
        className="min-h-screen flex items-center py-20 bg-gradient-to-br from-cyan-50 via-blue-50 to-indigo-50"
      >
        <div className="w-full px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                🌏 热门地点
              </div>
              <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
                <span className="bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-600 bg-clip-text text-transparent">
                  学习地点
                </span>
                <br />
                选择
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {destinations.map((dest, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-3xl p-8 shadow-xl border-2 border-gray-100 hover:border-transparent hover:shadow-2xl transition-all duration-300"
                  style={{
                    animation: visibleSections.has("destinations")
                      ? `fadeInScale 0.6s ease-out ${index * 0.15}s both`
                      : "none",
                  }}
                >
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${dest.color} rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10`}
                  ></div>
                  <div className="absolute inset-[2px] bg-white rounded-3xl -z-10"></div>

                  <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300 ">
                    {/* {dest.flag} */}
                    <img
                      src={dest.flag}
                      alt=""
                      className="h-16 w-28 border border-black"
                    />
                  </div>
                  <h3 className="font-black text-2xl text-gray-900 mb-3">
                    {dest.country}
                  </h3>
                  <p className="text-gray-600 font-medium mb-4 leading-relaxed">
                    {dest.description}
                  </p>
                  <div className="bg-gray-50 rounded-xl p-3 mb-4">
                    <p className="text-sm font-bold text-gray-700">
                      首选:{" "}
                      <span className="text-blue-600">{dest.universities}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-10">
              <button
                onClick={() =>
                  document
                    .getElementById("form-section")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white font-black px-8 py-4 rounded-2xl shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
              >
                免费了解奖学金，大学和学费
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Universities - Horizontal Scroll on Mobile */}
      <section
        id="universities"
        data-animate
        className="min-h-screen flex items-center py-20 bg-white relative overflow-hidden"
      >
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 left-10 w-32 h-32 border-4 border-blue-300 rounded-3xl rotate-12"></div>
          <div className="absolute bottom-20 right-10 w-40 h-40 border-4 border-purple-300 rounded-full"></div>
          <div className="absolute top-1/2 left-1/4 w-24 h-24 border-4 border-indigo-300 rounded-2xl -rotate-12"></div>
        </div>

        <div className="relative z-10 w-full px-4">
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
              🌟 热门推荐
            </div>
            <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
              全球顶尖大学
              <br />
              <span className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 bg-clip-text text-transparent">
                等待您
              </span>
            </h2>
            <p className="text-gray-600 font-medium">在全球顶尖大学深造 🎓</p>
          </div>

          {/* Mobile: Horizontal Scroll, Desktop: Grid */}
          <div className="lg:max-w-6xl lg:mx-auto">
            <div className="flex lg:grid lg:grid-cols-2 gap-6 overflow-x-auto lg:overflow-visible snap-x snap-mandatory pb-4 px-4 lg:px-0 scrollbar-hide">
              {featuredUniversities.map((uni, index) => (
                <div
                  key={uni.id}
                  className="flex-shrink-0 w-[85vw] sm:w-[70vw] lg:w-auto snap-center"
                  style={{
                    animation: visibleSections.has("universities")
                      ? `slideInUp 0.6s ease-out ${index * 0.1}s both`
                      : "none",
                  }}
                >
                  <div className="group relative bg-white rounded-3xl p-6 shadow-xl border-2 border-gray-100 hover:border-transparent hover:shadow-2xl transition-all duration-300 h-full">
                    {/* Gradient Border Effect */}
                    <div
                      className={`absolute inset-0 bg-gradient-to-br ${uni.color} rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10`}
                    ></div>
                    <div className="absolute inset-[2px] bg-white rounded-3xl -z-10"></div>

                    {/* University Image Placeholder */}
                    <div
                      className={`bg-gradient-to-br ${uni.color} h-40 rounded-2xl mb-4 flex items-center justify-center relative overflow-hidden`}
                    >
                      <div className="absolute inset-0 opacity-20">
                        <div className="absolute top-0 left-0 w-20 h-20 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
                        <div className="absolute bottom-0 right-0 w-32 h-32 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
                      </div>
                      <span className="text-6xl relative">
                        <img src={uni.image} alt="" className="w-32" />
                      </span>
                    </div>

                    {/* Country Badge */}
                    <div className="mb-3">
                      <span className="inline-block bg-white px-3 py-1 rounded-full text-xs font-black border-2 border-gray-200">
                        {uni.country}
                      </span>
                    </div>

                    {/* Scholarship Badge */}
                    <div className="absolute top-10 right-10 bg-gradient-to-r from-amber-400 to-orange-500 text-white px-4 py-2 rounded-full text-xs font-black shadow-lg rotate-3 transform group-hover:rotate-6 transition-transform">
                      {uni.scholarship}
                    </div>

                    <h3 className="font-black text-xl text-gray-900 mb-3 line-clamp-2">
                      {uni.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-6 line-clamp-3">
                      {uni.description}
                    </p>

                    <button
                      onClick={() => {
                        const uniIndex = overseasUniversities.findIndex(
                          (u) => u.fullName === uni.name
                        );
                        if (uniIndex !== -1) {
                          setActiveUniversity(uniIndex);
                        }
                        document
                          .getElementById("more-universities")
                          ?.scrollIntoView({ behavior: "smooth" });
                      }}
                      className="w-full bg-gradient-to-r from-gray-900 to-gray-700 hover:from-gray-800 hover:to-gray-600 text-white font-bold py-3 rounded-xl transition-all duration-300 group-hover:scale-105 cursor-pointer"
                    >
                      了解更多 →
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Scroll Hint for Mobile */}
          <div className="lg:hidden text-center mt-6">
            <p className="text-sm text-gray-400 font-semibold">
              ← 滑动查看更多 →
            </p>
          </div>

          {/* View Full List Button */}
          <div className="text-center mt-12">
            <button
              onClick={() =>
                document
                  .getElementById("more-universities")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-black px-10 py-4 rounded-2xl shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              探索 10 多所合作大学 🌍
            </button>
            <p className="text-sm text-gray-500 mt-4 font-semibold">
              比较课程、费用和奖学金
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section - Bento Grid Style */}
      <section
        id="benefits"
        data-animate
        className="min-h-screen flex items-center py-20 bg-gradient-to-br from-cyan-50 via-blue-50 to-indigo-50 relative overflow-hidden"
      >
        <div className="w-full px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                🎁 专属福利
              </div>
              <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
                学生为何选择
                <br />
                <span className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 bg-clip-text text-transparent">
                  SCS Education
                </span>
              </h2>
              <p className="text-xl text-gray-600 font-medium">
                数千名海外留学成功案例
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-purple-300"
                  style={{
                    animation: visibleSections.has("benefits")
                      ? `fadeInScale 0.6s ease-out ${index * 0.1}s both`
                      : "none",
                  }}
                >
                  <div className="text-5xl mb-4 group-hover:scale-110 transition-transform duration-300">
                    {benefit.emoji}
                  </div>
                  <h3 className="font-black text-2xl text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 font-medium leading-relaxed">
                    {benefit.description}
                  </p>

                  {/* Decorative Corner */}
                  <div className="absolute top-4 right-4 w-12 h-12 border-4 border-purple-200 rounded-xl rotate-12 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Partner Universities - Tabbed Interface */}
      <section
        id="more-universities"
        data-animate
        className="relative min-h-screen flex items-center py-20 bg-gradient-to-br from-gray-50 via-white to-blue-50/30"
      >
        <div className="w-full px-4">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                🌍 合作大学
              </div>
              <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
                探索我们的
                <br />
                <span className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent">
                  国际合作大学
                </span>
              </h2>
              <p className="text-xl text-gray-600 font-medium max-w-2xl mx-auto">
                比较课程、费用和奖学金
              </p>
            </div>

            {/* University Tabs - Horizontal Scroll on Mobile */}
            <div className="mb-8 overflow-x-auto scrollbar-hide px-4 -mx-4 lg:px-0 lg:mx-0">
              <div className="flex lg:grid grid-cols-8 gap-2 pb-4 min-w-max lg:justify-center px-4 lg:px-0">
                {overseasUniversities.map((uni, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveUniversity(index)}
                    className={`px-6 py-3 rounded-xl font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      activeUniversity === index
                        ? `bg-gradient-to-r ${uni.color} text-white shadow-lg scale-105`
                        : "bg-white text-gray-600 border-2 border-gray-200 hover:border-gray-300"
                    }`}
                  >
                    {uni.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Scroll Hint for Mobile */}
            <div className="lg:hidden text-center -mt-4 mb-8">
              <p className="text-sm text-gray-400 font-semibold">
                ← 滑动查看更多大学 →
              </p>
            </div>

            {/* University Details Card */}
            <div className="bg-white rounded-3xl shadow-2xl border-2 border-gray-100 overflow-hidden">
              <div className="grid lg:grid-cols-3 gap-0">
                {/* Left Column - University Info */}
                <div className="lg:col-span-1 p-8 bg-gradient-to-br from-gray-50 to-white border-r border-gray-100">
                  <div
                    className={`bg-white w-24 h-24 rounded-2xl mb-6 flex items-center justify-center mx-auto`}
                  >
                    <img src={overseasUniversities[activeUniversity].image} />
                  </div>

                  <h3 className="text-2xl font-black text-gray-900 mb-2 text-center">
                    {overseasUniversities[activeUniversity].fullName}
                  </h3>
                  <p className="text-gray-600 font-semibold mb-6 text-center">
                    📍 {overseasUniversities[activeUniversity].location}
                  </p>

                  {/* Stats */}
                  <div className="space-y-4">
                    <div className="bg-white rounded-xl p-4 border-2 border-blue-200">
                      <div className="flex items-center gap-3">
                        <span className="text-2xl">⭐</span>
                        <div>
                          <div className="text-sm font-bold text-blue-600">
                            排名
                          </div>
                          <div className="font-black text-gray-900">
                            {overseasUniversities[activeUniversity].ranking}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-xl p-4 border-2 border-indigo-200">
                      <div className="flex items-center gap-3">
                        <span className="text-2xl">🎁</span>
                        <div>
                          <div className="text-sm font-bold text-indigo-600">
                            奖学金
                          </div>
                          <div className="font-black text-gray-900">
                            {
                              overseasUniversities[activeUniversity]
                                .scholarships
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-xl p-4 border-2 border-purple-200">
                      <div className="flex items-center gap-3">
                        <span className="text-2xl">💼</span>
                        <div>
                          <div className="text-sm font-bold text-purple-600">
                            就业率
                          </div>
                          <div className="font-black text-gray-900">
                            {overseasUniversities[activeUniversity].employment}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Description & Courses */}
                <div className="lg:col-span-2 p-8">
                  <p className="text-gray-700 text-lg leading-relaxed mb-8 font-medium">
                    {overseasUniversities[activeUniversity].description}
                  </p>

                  <h4 className="text-2xl font-black text-gray-900 mb-6">
                    热门课程
                  </h4>

                  <div className="grid sm:grid-cols-2 gap-4 mb-8">
                    {overseasUniversities[activeUniversity].courses.map(
                      (course, idx) => (
                        <div
                          key={idx}
                          className="group bg-gradient-to-br from-gray-50 to-white rounded-xl p-4 border-2 border-gray-200 hover:border-blue-300 transition-all duration-300 relative overflow-hidden"
                        >
                          <div
                            className={`absolute inset-0 bg-gradient-to-br ${overseasUniversities[activeUniversity].color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
                          ></div>

                          <h5 className="font-black text-base text-gray-900 mb-2">
                            {course.name}
                          </h5>
                          <div className="flex items-baseline gap-2">
                            <p className="text-xs text-gray-500 font-semibold">
                              从
                            </p>
                            <p className="text-xl font-black bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                              {course.fee}
                            </p>
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  {/* CTA Button */}
                  <button
                    onClick={() =>
                      document
                        .getElementById("form-section")
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="w-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 text-white font-black text-lg py-5 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer"
                  >
                    立即申请 - 获取免费咨询 🚀
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories - Card Carousel */}
      <section
        id="testimonials"
        data-animate
        className="min-h-screen flex items-center py-20 bg-gradient-to-br from-cyan-50 via-blue-50 to-indigo-50"
      >
        <div className="w-full px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                ⭐ 成功案例
              </div>
              <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
                真实的学生案例
                <br />
                <span className="bg-gradient-to-r from-green-500 via-teal-500 to-blue-500 bg-clip-text text-transparent">
                  海外留学生的评价
                </span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className={`${testimonial.color} rounded-3xl p-8 shadow-xl border-2 border-white hover:scale-105 transition-transform duration-300`}
                  style={{
                    animation: visibleSections.has("testimonials")
                      ? `fadeInUp 0.6s ease-out ${index * 0.15}s both`
                      : "none",
                  }}
                >
                  {/* Quote Icon */}
                  <div className="text-5xl mb-4 opacity-50">"</div>

                  <p className="text-gray-800 font-semibold text-lg mb-6 leading-relaxed italic">
                    {testimonial.quote}
                  </p>

                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-400 to-indigo-400 rounded-full flex items-center justify-center text-white font-black text-xl shadow-lg">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <div className="font-black text-gray-900">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-gray-600 font-semibold">
                        {testimonial.destination}
                      </div>
                      <div className="text-xs text-gray-500 font-medium">
                        {testimonial.uni}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section - Accordion Style */}
      <section
        id="faq"
        data-animate
        className="min-h-screen flex items-center py-20 bg-white"
      >
        <div className="w-full px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                ❓ FAQ
              </div>
              <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
                有疑问吗？
                <br />
                <span className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent">
                  放心，让我们为您解答
                </span>
              </h2>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-6 border-2 border-gray-200 hover:border-blue-300 transition-all duration-300 shadow-sm hover:shadow-lg"
                  style={{
                    animation: visibleSections.has("faq")
                      ? `fadeInUp 0.5s ease-out ${index * 0.1}s both`
                      : "none",
                  }}
                >
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center text-white font-black text-sm">
                      Q
                    </div>
                    <div className="flex-1">
                      <h3 className="font-black text-lg text-gray-900 mb-3">
                        {faq.question}
                      </h3>
                      <p className="text-gray-600 font-medium leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer
        aboutTitle={footerData.aboutTitle}
        aboutDesc={footerData.aboutDesc}
        partnerUniTitle={footerData.partnerUniTitle}
        partnerUni={footerData.partnerUni}
        contactTitle={footerData.contactTitle}
        contact={footerData.contact}
        linkPath="/top-overseas-universities-cn"
      />

      {/* CSS Animations */}
      <style>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }

        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        @media (min-width: 1024px) {
          html {
            scroll-snap-type: y proximity;
          }
          
          section {
            scroll-snap-align: start;
          }
        }
      `}</style>
    </div>
  );
};

export default OverseasUniversitiesPageCN;
